<script>
/* eslint-disable */
import DefaultMixin from '../mixin'

export default {
  name: 'Leilao',
  inject: ['page'],
  mixins: [DefaultMixin],
  components: {},
  data() {
    return {
      leilao: this.page.leilao
    }
  },
  computed: {
    listType () {
      return this.$route.name
    }
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    changeListType(v) {
      this.$router.push({name: v})
    }
  },
  meta: {
    title: 'Preparação',
    name: 'Preparação'
  }
}
</script>

<template>
  <div class="page-leilao-container">
    <div class="h-full">
      <div class="page-tab">
        <div class="erp-list list-tasks no-pad">
          <div class="erp-list-top-btns items-end">
            <div class="actives-btns col-grow-1" style="margin-left: 60px">
              <u-btn @click="changeListType('leiloes.preparacao.loteamento')" class="active-table-btn" label="Loteamento Rápido" no-caps
                     :class="{active: listType === 'leiloes.preparacao.loteamento'}"/>
              <u-btn @click="changeListType('leiloes.preparacao.importacao')" class="active-table-btn" label="Importação por Planilha" no-caps
                     :class="{active: listType === 'leiloes.preparacao.importacao'}"/>
              <u-btn @click="changeListType('leiloes.importacao-avancada')" class="active-table-btn" label="Importação com Análise" no-caps
                     :class="{active: listType === 'leiloes.importacao-avancada'}"/>
            </div>
          </div>
        </div>
        <div class="page-content">
        <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
